import type { ReaderTheme } from '@/features/reader/components/reader-display-settings/utils/reader-display-settings';

export function applyReaderTheme(node: HTMLElement, theme: ReaderTheme) {
  node.dataset.readerTone = theme.tone;
  node.style.background = theme.background;
  node.style.color = theme.text;
  node.style.setProperty('--reader-bg', theme.background);
  node.style.setProperty('--reader-text', theme.text);
  node.style.setProperty('--reader-surface', theme.surface);
  node.style.setProperty('--reader-muted', theme.muted);
}
